export const columnsDefault = {
  // FlightOrdersView initiator
  'initiatorFlightOrderRow-personColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'pnr',
    'shortName',
    'orderData.docNum',
    'orderData.mvz',
    'organization',
    'birthDateStr',
    'orderData.contacts',
    'orderData.email',
    'orderData.timeFrom',
    'orderData.initiator',
    'processData.orderStatus'
  ],
  'initiatorFlightOrderRow-cargoColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'pnr',
    'orderData.placeCount',
    'orderData.name',
    'orderData.dimensions',
    'orderData.weight',
    'orderData.mvz',
    'organization',
    'orderData.packType',
    'orderData.transportType',
    'orderData.timeFrom',
    'orderData.initiator',
    'processData.orderStatus'
  ],
  // FlightOrdersView planner
  'plannerFlightOrderRow-personColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'pnr',
    'shortName',
    'orderData.docNum',
    'orderData.mvz',
    'organization',
    'birthDateStr',
    'orderData.contacts',
    'orderData.email',
    'orderData.timeFrom',
    'orderData.initiator',
    'processData.orderStatus'
  ],
  'plannerFlightOrderRow-cargoColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'pnr',
    'orderData.placeCount',
    'orderData.name',
    'orderData.dimensions',
    'orderData.weight',
    'orderData.mvz',
    'organization',
    'orderData.packType',
    'orderData.transportType',
    'orderData.timeFrom',
    'orderData.initiator',
    'processData.orderStatus'
  ],
  'transferFlightOrderRow-personColumns': [
    'pnr',
    'shortName',
    'orderData.docNum',
    'organization',
    'orderData.contacts',
    'orderData.initiatorPhone',
    'medcheck',
    'register'
  ],
  'transferFlightOrderRow-cargoColumns': [
    'pnr',
    'organization',
    'orderData.name',
    'orderData.placeCount',
    'orderData.packType',
    'orderData.weight',
    'orderData.transportType',
    'orderData.initiator',
    'orderData.initiatorPhone',
    'register'
  ],
  'readyToFlightOrders-personColumns': [
    'pnr',
    'orderData.fullName',
    'organization',
    'orderData.contacts',
    'orderData.initiatorPhone',
    'medcheck',
    'register'
  ],
  'medicFlightOrderRow-personColumns': [
    'pnr',
    'shortName',
    'orderData.docNum',
    'organization',
    'orderData.contacts',
    'orderData.initiatorPhone',
    'medcheck'
  ],
  'plannerFlights-personColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'pnr',
    'shortName',
    'orderData.docNum',
    'orderData.mvz',
    'organization',
    'birthDateStr',
    'orderData.contacts',
    'orderData.email',
    'orderData.timeFrom',
    'orderData.initiator',
    'processData.orderStatus'
  ],
  'plannerFlights-cargoColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'pnr',
    'orderData.placeCount',
    'orderData.name',
    'orderData.dimensions',
    'orderData.weight',
    'orderData.mvz',
    'organization',
    'orderData.packType',
    'orderData.transportType',
    'orderData.timeFrom',
    'orderData.initiator',
    'processData.orderStatus'
  ],
  'finalApproveOrderRow-personColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'pnr',
    'shortName',
    'orderData.docNum',
    'orderData.mvz',
    'organization',
    'birthDateStr',
    'orderData.contacts',
    'orderData.email',
    'orderData.timeFrom',
    'orderData.initiator',
    'orderData.initiatorPhone',
    'orderData.initiatorEmail',
    'processData.orderStatus'
  ],
  'finalApproveOrderRow-cargoColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'pnr',
    'orderData.placeCount',
    'orderData.name',
    'orderData.dimensions',
    'orderData.weight',
    'orderData.mvz',
    'organization',
    'orderData.packType',
    'orderData.transportType',
    'orderData.timeFrom',
    'orderData.initiator',
    'orderData.initiatorPhone',
    'orderData.initiatorEmail',
    'processData.orderStatus'
  ],
  'uploadOrdersPreview-personColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'shortName',
    'orderData.docNum',
    'orderData.mvz',
    'organization',
    'birthDateStr',
    'orderData.contacts',
    'orderData.email',
    'orderData.timeFrom'
  ],
  'uploadOrdersPreview-cargoColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'orderData.placeCount',
    'orderData.name',
    'orderData.dimensions',
    'orderData.weight',
    'orderData.mvz',
    'organization',
    'orderData.packType',
    'orderData.transportType',
    'orderData.timeFrom'
  ],
  'addFactPreview-personColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'shortName',
    'orderData.docNum',
    'orderData.mvz',
    'organization',
    'birthDateStr'
  ],
  'addFactPreview-cargoColumns': [
    'flightDateString',
    'depPortLabels.code',
    'arrPortLabels.code',
    'orderData.placeCount',
    'orderData.name',
    'orderData.dimensions',
    'orderData.weight',
    'orderData.mvz',
    'organization',
    'orderData.packType'
  ]
}
export const columnsFull = {
  // common
  'flightDateString': {
    dateFormat: 'YYYY-MM-DD',
    width: 75,
    number: 10
  },
  'depPortLabels.code': {
    width: 40,
    number: 20
  },
  'arrPortLabels.code': {
    width: 40,
    number: 30
  },
  'pnr': {
    width: 45,
    number: 40
  },
  'orderData.mvz': {
    width: 'auto',
    maxWidth: 80,
    number: 110
  },
  'organization': {
    width: 'auto',
    number: 120
  },
  'orderData.timeFrom': {
    width: 'auto',
    maxWidth: 80,
    number: 180
  },
  'orderData.initiator': {
    width: 'auto',
    number: 190
  },
  'orderData.initiatorPhone': {
    width: 'auto',
    number: 193
  },
  'orderData.initiatorEmail': {
    width: 'auto',
    number: 196
  },
  'processData.orderStatus': {
    width: 'auto',
    maxWidth: 100,
    number: 200
  },
  'register': {
    width: 150,
    number: 220
  },
  'orderData.comments': {
    width: 150,
    number: 230
  },
  // person
  'shortName': {
    width: 'auto',
    isOnlyPerson: true,
    number: 50
  },
  'orderData.fullName': {
    width: 'auto',
    isOnlyPerson: true,
    number: 55
  },
  'orderData.docNum': {
    width: 'auto',
    isOnlyPerson: true,
    number: 60
  },
  'birthDateStr': {
    width: 75,
    isOnlyPerson: true,
    number: 130
  },
  'orderData.contacts': {
    width: 'auto',
    maxWidth: 100,
    isOnlyPerson: true,
    number: 140
  },
  'orderData.email': {
    width: 'auto',
    isOnlyPerson: true,
    number: 150
  },
  'medcheck': {
    width: 'auto',
    isOnlyPerson: true,
    number: 210
  },
  // cargo
  'orderData.placeCount': {
    width: 'auto',
    isOnlyCargo: true,
    number: 70
  },
  'orderData.name': {
    width: 'auto',
    isOnlyCargo: true,
    number: 80
  },
  'orderData.dimensions': {
    width: 'auto',
    isOnlyCargo: true,
    number: 90
  },
  'orderData.weight': {
    width: 'auto',
    isOnlyCargo: true,
    number: 100
  },
  'orderData.packType': {
    width: 'auto',
    isOnlyCargo: true,
    number: 160
  },
  'orderData.transportType': {
    width: 'auto',
    isOnlyCargo: true,
    number: 170
  }
}



// WEBPACK FOOTER //
// ./src/utils/columnLists.js